import { BaseFieldOptionsModel } from '../base-field-options.model';
import { IBooleanFieldOptions } from '../../../../interface/custom-lists/boolean-field-options.interface';

export class BooleanFieldOptionsModel extends BaseFieldOptionsModel implements IBooleanFieldOptions {}